<template>
  <div>
    <aru-calendar-list
      fetch-url="/calendar-event/all"
      :key="componentKey"
      action-button
      @actionButtonClicked="showEventForm = true"
      v-model="dateEvent"
      @clickOnPicker="clickOnPicker"
      @eventItemClicked="clicked"
      date-field="date"
      event-display-field="name"
      event-display-status-field="status"
      event-default-color="grey"
      :event-type-colors="typeColors"
      event-type-field="typeColor"
      entity="calendar-event"
    ></aru-calendar-list>

    <v-dialog persistent v-model="showEventForm" max-width="500">
      <consultant-date-form @closeDialog="closeDialog" :date="dateEvent"></consultant-date-form>
    </v-dialog>

    <v-dialog v-model="showEventDetail" max-width="500">
      <calendar-event-detail
        @closeDialog="closeDetailDialog"
        :calendar-event="eventDetail"
      ></calendar-event-detail>
    </v-dialog>
  </div>
</template>

<script>
import AruCalendarList from '@/components/commons/list/AruCalendarList';
import ConsultantDateForm from './ConsultantDateForm.vue';
import CalendarEventDetail from './CalendarEventDetail.vue';

export default {
  components: {
    AruCalendarList,
    ConsultantDateForm,
    CalendarEventDetail,
  },
  data() {
    return {
      typeColors: {
        global: 'secondary',
        Laboral: 'primary',
        Fiscal: 'blue darken-4',
        Contable: 'pink',
        Otros: 'grey',
        autonomous: 'secondary',
        pyme: 'secondary',
        employees: 'secondary',
        'consultant-date': 'deep-purple',
      },
      date: null,
      dateEvent: null,
      showDateMenu: false,
      x: 0,
      y: 0,
      showEventForm: false,
      componentKey: 0,
      showEventDetail: false,
      eventDetail: {},
    };
  },
  mounted() {},
  methods: {
    clicked(dateEvent) {
      console.log(dateEvent);
      this.eventDetail = dateEvent;
      this.showEventDetail = true;
    },
    clickOnPicker(e, data) {
      console.log('ClickOnPicker');
      console.log(this.$event);

      this.showDateMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showDateMenu = true;
      });
    },
    closeDialog(data) {
      this.showEventForm = false;
      console.log({ CloseDialogData: data });
      if (data.hasOwnProperty('id')) {
        this.componentKey += 1;
        // this.showEventList = false;
        // this.showEventList = true;
      }
    },

    closeDetailDialog() {
      this.showEventDetail = false;
      console.log('closeDetailDialog');
    },
    // showEventForm() {
    //     this.date = this.dateEvent;
    //     this.eventCategory = ['otros'];
    //     this.dialogTitle = "Añadir un evento al calendario";
    //     this.dialog = true;
    // },
    // showFiscalForm() {
    //     this.date = this.dateEvent;
    //     this.eventCategory = ['fiscal'];
    //     this.dialogTitle = "Pedir cita con el asesor";
    //     this.dialog = true;

    // },
    // showCountableForm() {
    //     this.date = this.dateEvent;
    //     this.eventCategory = ['contable'];
    //     this.dialogTitle = "Pedir cita con el asesor";
    //     this.dialog = true;

    // },
    // showLaboralForm() {
    //     this.date = this.dateEvent;
    //     this.eventCategory = ['laboral'];
    //     this.dialogTitle = "Pedir cita con el asesor";
    //     this.dialog = true;

    // },
    // allowedHours: v => v <= 19 && v >= 9 && (v < 15 || v > 16),
    // allowedMinutes: v => v % 5 == 0,
  },
};
</script>

<style></style>
